import { render, staticRenderFns } from "./AppAlertsCardVehicle.vue?vue&type=template&id=be13e6d6&scoped=true&"
import script from "./AppAlertsCardVehicle.vue?vue&type=script&lang=js&"
export * from "./AppAlertsCardVehicle.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertsCardVehicle.vue?vue&type=style&index=0&id=be13e6d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be13e6d6",
  null
  
)

export default component.exports